// We force cast the envvar to string because
// it is more convenient for consumer.
// Note that the envvar must start with
// REACT_APP_ as documented in CRA documentation.
export const MY_API_SERVER_API_KEY = process.env
  .REACT_APP_MY_API_SERVER_API_KEY as string;
export const apiUrl: string = "api.wwxplorer.com";
export const mainSite: string = "www.wwxplorer.com";
export const email: string = "cs@wwxplorer.com";
export const phone: string = "+852 2560 6696";
export const startDate: Date = new Date(2018, 9, 22);
export const endDate: Date = new Date(2018, 10, 30);



// WEBPACK FOOTER //
// ./src/config.ts